import { FC, useCallback, useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toasterSlice } from "./store/slice";
import styles from "./toaster.module.scss";

interface IToastData {
  title: string;
  style: string;
}

const Toaster: FC = () => {
  const [hideQueue, setHideQueue] = useState<string[]>([]);

  const queue = useSelector((state) => state.toaster.queue);

  const dispatch = useDispatch();

  const hide = useCallback(
    (id: string) => dispatch(toasterSlice.actions.hide(id)),
    [dispatch]
  );

  const getToastData = useCallback((variant: string): IToastData | null => {
    let toastData: IToastData | null = null;

    switch (variant) {
      case "success":
        toastData = {
          title: "Success",
          style: styles.success,
        };
        break;
      case "danger":
        toastData = {
          title: "Error",
          style: styles.danger,
        };
        break;
      case "info":
        toastData = {
          title: "Info",
          style: styles.info,
        };
        break;
      case "warning":
        toastData = {
          title: "Warning",
          style: styles.warning,
        };
        break;
    }

    return toastData;
  }, []);

  useEffect(() => {
    if (!!queue.length) {
      queue.forEach(({ id }) => {
        if (!hideQueue.includes(id)) {
          setTimeout(() => {
            hide(id);
          }, 8000);

          setHideQueue(hideQueue.concat(id));
        }
      });
    }
  }, [queue, hideQueue, hide]);

  return (
    <ToastContainer className={styles.toasterDiv}>
      {queue.map(({ id, variant, message }, index) => {
        if (!variant) {
          return null;
        }

        const toastData = getToastData(variant);

        if (!toastData) {
          return null;
        }

        const { style, title } = toastData;

        return (
          <Toast key={index} onClose={() => hide(id)} className={styles.toast}>
            <Toast.Header className={style}>
              <strong className="me-auto">{title}</strong>
              <small>Just now</small>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
          </Toast>
        );
      })}
    </ToastContainer>
  );
};

export { Toaster };
